import React, {useCallback, useContext, useEffect, useRef, useState} from 'react';
import {TickProvider} from "../../contexts/TickContext";
import "../css/StockTrackingRow.css";
import {handleTradingsymbolClick} from '../../services/apiService';  // Import the function to fetch holding quantity
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import ChangePercent from "./ChangePercent";
import LastTradedPriceDisplay from "./LastTradedPriceDisplay";
import {handlePriceDifferenceChange} from "../../marketwatch/gridcomponents/guiinstrumentrow/InstrumentUtils";
/*import MoreDetailsLayout from "./MoreDetails/MoreDetailsLayout";*/
import PositionPriceDisplay from "@dashboard/stocktracking/components/StockTrackingPriceDisplay";
import MoreDetailsLayout from "./MoreDetails/MoreDetailsLayout";
import PriceDifferenceDisplay from "./PriceDifferenceDisplay";
import {DataContext} from "../../contexts/DataContext";

const StockTrackingRow = ({trackedStock, uniqueId, onPriceDifferenceUpdate, setLayouts, layoutIndex}) => {
    const [holdingQuantity, setHoldingQuantity] = useState(null);  // State to store holding quantity
    const [isFetching, setIsFetching] = useState(true);  // State to track fetching status
    const [priceColor, setPriceColor] = useState('black');  // Set default color for tradingsymbol
    const [changePercColor, setChangePercColor] = useState('black');  // Set default color for tradingsymbol
    const [lastPriceColor, setLastPriceColor] = useState('black');  // Set default color for last-traded-price
    const rowWrapperRef = useRef(null);
    const {screenerURLs} = useContext(DataContext);

/*    // Fetch holding quantity when the component is mounted
    useEffect(() => {
        const fetchHoldingQuantity = async () => {
            const quantity = await getHoldingQuantity(trackedStock.tradingsymbol);
            setHoldingQuantity(quantity);
            setIsFetching(false);  // Mark as done fetching
        };

        fetchHoldingQuantity();
    }, [trackedStock.tradingsymbol]);*/

// Use the utility function for price difference change
    const handlePriceDifference = useCallback(handlePriceDifferenceChange(onPriceDifferenceUpdate, trackedStock), [
        trackedStock.instrumentToken,
        onPriceDifferenceUpdate
    ]);

    return (
        <TickProvider key={uniqueId} instrumentToken={trackedStock.instrumentToken}>
            <div className="trackedStock-row-wrapper" ref={rowWrapperRef}>

                <div className="trackedStock-row">
                    <div className="trackedStock-info">
                        <div className="symbol_n_exchange-st">
                            <span className="tradingsymbol-st" style={{color: priceColor}}
                                  onClick={() => handleTradingsymbolClick(trackedStock.tradingsymbol,screenerURLs)}>
                                {trackedStock.tradingsymbol}
                            </span>
                            <span className="exchange-name">{trackedStock.exchangeName}</span>
                        </div>
                        <PriceDifferenceDisplay
                            priceColor={priceColor}
                            setPriceColor={setPriceColor}
                            setLastPriceColor={setLastPriceColor}  // Pass color change for last-traded-price
                            onPriceDifferenceChange={handlePriceDifference}
                            contextName={'TickContext'}
                        />
                        <div className="trackedStock-price-st">
                            <span>
                                {trackedStock.avgBuyPrice}
                            </span>
                        </div>
                        <LastTradedPriceDisplay
                            priceColor={lastPriceColor}  // Pass the color for last-traded-price
                            contextName={'TickContext'}
                        />
                        <ChangePercent
                            trackedStock={trackedStock}
                            changePercColor={changePercColor}  // Pass the color for last-traded-price
                            setChangePercColor={setChangePercColor}
                            onPriceDifferenceChange={handlePriceDifference}
                            contextName={'TickContext'}
                        />
                    </div>
                    {trackedStock.isDetailsVisible && (
                        <div className="moredetails-st">
                        <MoreDetailsLayout
                            setLayouts={setLayouts}
                            instrumentToken={trackedStock.instrumentToken}
                            layoutIndex={layoutIndex}
                            rowWrapperRef={rowWrapperRef}
                            contextName={'TickContext'}
                            extraClassName="from-trackedStock-row"
                        />
                        </div>
                    )}
                </div>
            </div>
        </TickProvider>
    );
};

export default StockTrackingRow;
